export default __webpack_public_path__ + "static/media/general_funnel_guide.cefded6b.png";